import React, { useEffect, useState } from 'react';
import './Alert.css';
import { ReactComponent as CheckmarkIcon } from '../../assets/icons/checkmark-icon.svg';
import { ReactComponent as XmarkIcon } from '../../assets/icons/close-icon.svg';

const Alert = ({ message, submessage, success, timeout, onClose }) => {
  const [visible, setVisible] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Mount first to trigger animation
    setMounted(true);
    
    const timer = setTimeout(() => {
      setMounted(false); // Trigger slide-out animation
      // Wait for animation to complete before unmounting
      const unmountTimer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, 300); // Match transition duration
      return () => clearTimeout(unmountTimer);
    }, timeout || 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClose = () => {
    setMounted(false);
    setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, 300); // Match transition duration
  };

  if (!visible) return null;

  return (
    <div className={`alert-container ${mounted ? 'visible' : ''} ${success ? 'success' : 'error'}`}>
        <div className="alert-icon">{success ? <CheckmarkIcon className="icon" /> : <XmarkIcon className="icon" />}</div>
        <div className="alert-content">
            <div className="alert-message">{message}</div>
            {submessage && <div className="alert-submessage">{submessage}</div>}
            <button className="alert-close" onClick={handleClose}>
                &#10005;
            </button>
        </div>
    </div>
  );
};

export default Alert;